import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import LoginFormPage from './pages/LoginFormPage';
import KakaoLoginPage from './pages/KakaoLoginPage';
import HomeForAdmin from './pages/HomeForAdmin';
import MainPage from './pages/MainPage';
import ReadingScriptStatisticsPage from './pages/ReadingScriptStatisticsPage';
import MeetingStatisticsPage from './pages/MeetingStatisticsPage';
import MemberManagementPage from './pages/MemberManagementPage';
import MeetingManagementPage from './pages/MeetingManagementPage';
import OperationSettingsPage from './pages/OperationSettingsPage';
import BannerManagementPage from './pages/BannerManagementPage';

const App = () => {
  return (
    <Router>
      <Routes>
        {/* 로그인 영역 */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/login/form" element={<LoginFormPage />} />
        <Route path="/login/kakao" element={<KakaoLoginPage />} />

        {/* 메인 레이아웃 */}
        <Route path="/main" element={<MainPage />}>
          <Route path="dashboard" element={<HomeForAdmin />} />
          <Route
            path="reading-scripting-statistics"
            element={<ReadingScriptStatisticsPage />}
          />
          <Route
            path="meeting-statistics"
            element={<MeetingStatisticsPage />}
          />
          <Route
            path="member-management"
            element={<MemberManagementPage />}
          />
          <Route
            path="meeting-management"
            element={<MeetingManagementPage />}
          />
          <Route
            path="operation-settings"
            element={<OperationSettingsPage />}
          />
          <Route
            path="banner-management"
            element={<BannerManagementPage />}
          />
          {/* 샘플: 메뉴2-1 페이지 */}
          <Route
            path="subpage10-1"
            element={<div>10-1. 메뉴10-1 컨텐츠 영역 입니다.</div>}
          />
        </Route>

        {/* 예전 경로 호환용 (선택사항) */}
        <Route path="/home-for-admin" element={<Navigate to="/main/dashboard" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
